import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/** Inbox 에서 열었을 때 — 관련 모듈로 내리고 약 2초 강조한다 (location.state.inboxFocus) */

export const LIT_MS = 2000;
export const litClass = (on) =>
  on ? 'bg-surface-green10 shadow-[inset_0_0_0_1px_#1dc37b]' : '';

const useInboxFocus = (ready = true) => {
  const location = useLocation();
  const navigate = useNavigate();
  const focus = location.state?.inboxFocus;
  const [lit, setLit] = useState(null);
  const handled = useRef(null);
  const timer = useRef(null);

  useEffect(() => () => window.clearTimeout(timer.current), []);

  useEffect(() => {
    if (!focus || !ready || handled.current === focus.key) return;
    handled.current = focus.key;
    setLit(focus);
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setLit(null), LIT_MS);
    const { inboxFocus, ...rest } = location.state;
    navigate(
      { pathname: location.pathname, search: location.search, hash: location.hash },
      { replace: true, state: Object.keys(rest).length ? rest : null },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focus?.key, ready]);

  useEffect(() => {
    if (!lit) return undefined;
    const scroll = () => {
      const el = document.querySelector('[data-inbox-lit="true"]');
      el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return !!el;
    };
    let retry;
    const raf = window.requestAnimationFrame(() => {
      if (!scroll()) retry = window.setTimeout(scroll, 150);
    });
    return () => {
      window.cancelAnimationFrame(raf);
      window.clearTimeout(retry);
    };
  }, [lit]);

  return lit;
};

export default useInboxFocus;
